import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";

const NotFoundPage = () => {
  return (
    <section>
      <ScrollToTop />
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-100">
            404
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Page Not Found.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Sorry the page your looking for does not exists :(
          </p>
          <Link
            to="/"
            className="inline-flex text-white bg-primary-50 hover:bg-primary-100 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
